import type { Theme } from "../tokens";

/** House dark, clinical. The lights are off in every room but this one. */
export const coroner: Theme = {
  id: "coroner",
  name: "Coroner",
  thesis: "House dark, clinical. The lights are off in every room but this one.",
  scheme: "dark",
  colors: {
    ground: "#0E0E0E",
    surface: "#1A1A1A",
    raised: "#242424",
    ink: "#F0EDE4",
    dim: "#8A8A85",
    rule: "#2E2E2E",
    lattice: "#242424",
    focus: "#C8DF00",
    inbox: "#C8DF00",
    feed: "#6E8FA6",
    paperTrail: "#9A9A90",
    screener: "#D07548",
  },
  type: {
    sans: "'Inter Tight', system-ui, sans-serif",
    mono: "'JetBrains Mono', ui-monospace, monospace",
    googleFonts: "Inter+Tight:wght@400;500;600&family=JetBrains+Mono:wght@400",
    tracking: "0",
  },
  density: {
    row: 44,
    primary: 15,
    secondary: 14,
    meta: 12,
    listWidth: 760,
    rail: 200,
    radius: 0,
    lineHeight: 1.4,
  },
  markers: {
    inbox: "●",
    feed: "◆",
    paperTrail: "▭",
    screener: "▲",
  },
};
